const initState = { data: null, error: null, message: null }

export default (state = { ...initState }, action) => {
  switch (action.type) {
    case "promoCodeIsValid":
      return {
        ...initState,
        data: action.data,
      }
    case "promoCodeIsInvalid":
      return {
        ...initState,
        message: "Promo Code Is Not Valid",
      }
    case "promoCodeNotFetched":
      // console.log(action);
      return {
        ...initState,
        error: action.err.message, // action.err.message || action.err
      }
    case "promoCodeUsageCountIncrement":
      console.log(`Promo Code Usage Count Incremented.`)
      return state
    case "promoCodeUsageCountIncrement_Failed":
      console.log(
        `Promo Code Usage Count Not Incremented. Error:\n${action.err}`
      )
      return state
    default:
      return state
  }
}
